// test2046
(2046 && 0);
